module.exports = __webpack_public_path__ + "static/media/StrengtheningOurSocialSupportNetwork.5b598cbf.mp3";